<template>
  <section class="container h-full max-w-full mx-auto px-4 sm:px-6 lg:px-8 pb-20 pt-0 sm:pt-5 md:pt-10 lg:pt-12">
    <Titre textePrincipal="Animaux " texteAccentue="perdus / trouvés" :isSidebarOpen="isSidebarOpen" />

    <!-- Section "Animaux perdus" avec formulaire -->
    <div class="max-w-7xl mx-auto flex flex-wrap flex-row justify-center items-stretch pb-4">
      <SectionCard :title="sections[0].title" :content="sections[0].content" :imageSrc="sections[0].imageSrc"
        :imageAlt="sections[0].imageAlt" :imageTitle="sections[0].imageTitle"
        :imagePosition="sections[0].imagePosition">
        <FormAnimauxPerdus />
      </SectionCard>
    </div>

    <div class="max-w-7xl mx-auto bg-gray-200 px-12 py-6 rounded-lg shadow-md mt-10">
      <p class="text-black text-base sm:text-xl md:text-2xl font-serif">Pour l'instant aucun animal perdu n'a été signalé.</p>
      <p class="text-black text-base sm:text-xl md:text-2xl font-serif">Je vous invite à visiter notre page <a class="underline text-navigation font-bold hover:no-underline hover:text-navigation" href="https://www.facebook.com/groups/1825547277688609" title="Facebook Animaux de la Seconde Chance" target="_blank" rel="noopener noreferrer">Facebook</a> pour voir les animaux perdus dans la région de Matane. Celle-ci est régulièrement mise à jour.</p>
    </div>

    <!-- Liste des animaux perdus -->
    <div
      class="max-w-7xl mx-auto mt-10 py-4 px-1 flex flex-wrap flex-row justify-center items-stretch gap-4 rounded-lg bg-gray-200">
      <CardBlanche
        v-for="(animal, index) in sections.slice(1)"
        :key="index"
        :imageSrc="animal.imageSrc"
        :altText="animal.imageAlt"
        :title="animal.title"
        :details="animal.content.length > 2 ? animal.content.slice(0, 2) : animal.content"
        :infoAdditionnel="animal.content.length > 2 ? animal.content[2] : ''"
      >
      <ContactAnimauxPerdus
        :email="animal.email && animal.email.trim() !== ''
          ? (
              animal.email
                .split(',')
                .map(e => e.trim())
                .includes('info@animauxdelasecondechance.com')
                ? animal.email
                : animal.email + ', info@animauxdelasecondechance.com'
            )
          : 'info@animauxdelasecondechance.com'"
        :animal="animal"
      />
      </CardBlanche>
    </div> 
  </section>
</template>

<script setup>
import Titre from '../composants/Titre.vue';
import FormAnimauxPerdus from '../composants/FormAnimauxPerdus.vue';
import SectionCard from '../composants/SectionCard.vue';
import CardBlanche from '../composants/CardBlanche.vue';
import ContactAnimauxPerdus from '../composants/ContactAnimauxPerdus.vue';
import { isSidebarOpen } from '../store/storeSideBar.js';

import animauxPerdusData from '../data/animauxPerdusData.json';

// Import dynamique des images des chats perdus
const images = import.meta.glob([
  '../assets/images/chats_perdus/*.webp',
  '../assets/images/*.webp'
], {
  eager: true,
  query: '?url',
  import: 'default'
});

const sections = animauxPerdusData.animauxPerdus.map(animal => {
  // On cherche dans les deux dossiers possibles
  let imagePathKey = `../assets/images/chats_perdus/${animal.imageFileName}`;
  if (!images[imagePathKey]) {
    imagePathKey = `../assets/images/${animal.imageFileName}`;
  }
  return {
    ...animal,
    imageSrc: images[imagePathKey] || ''
  };
});
</script>
